import React from 'react';

export default function SuccessMessage({ success }) {
  return <span className="text-success">{success}</span>;
}
